module.exports = __webpack_public_path__ + "images/bathroom-217a481e0e3f53cb2fc72f424626a5b7.jpg";